import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Insurance = ({ roles }) => {
    return (
        <M_Table entityName={'Insurance'} filtersOnTable rolePermissions={roles} />
    )
}